import React from "react";
import { useTiendaInfo } from "../../contexts/TiendaInfoContext";
import { useTemplateConfig } from "../../templates/templateConfigContext";

type LogoTiendaVariante = "horizontal" | "stacked";

interface LogoTiendaProps {
    variante?: LogoTiendaVariante;
    height?: number;
    width?: number;
    align?: "left" | "center";
}

const obtenerLogoDesdeBack = (tiendaInfo: unknown): string | null => {
    if (!tiendaInfo || typeof tiendaInfo !== "object") return null;

    const data = tiendaInfo as Record<string, unknown>;
    const candidatos = [
        data.urlLogo,
        data.vchUrlLogo,
        data.logoUrl,
        data.vchLogoUrl,
        data.urlLogoTienda,
        data.vchUrlLogoTienda,
        data.imagenLogoUrl,
        data.vchImagenLogoUrl,
    ];

    const encontrado = candidatos.find(
        (valor): valor is string => typeof valor === "string" && valor.trim().length > 0,
    );

    return encontrado?.trim() ?? null;
};

export default function LogoTienda({
    variante = "horizontal",
    height = 32,
    width,
    align = "left",
}: LogoTiendaProps) {
    const tiendaInfo = useTiendaInfo();
    const { config } = useTemplateConfig();
    const logoUrl = obtenerLogoDesdeBack(tiendaInfo);
    const nombre = tiendaInfo?.nombreTienda ?? config.identidad.vchNombreTienda;
    const texto = nombre || "Tienda";

    if (logoUrl) {
        return (
            <img
                src={logoUrl}
                alt={config.identidad.vchLogoAlt || texto}
                style={{
                    display: "block",
                    height,
                    width,
                    maxWidth: width ?? (variante === "stacked" ? 180 : 220),
                    objectFit: "contain",
                    objectPosition: align === "center" ? "center" : "left center",
                }}
            />
        );
    }

    return (
        <span
            aria-label={config.identidad.vchLogoAlt || texto}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: align === "center" ? "center" : "flex-start",
                minHeight: height,
                maxWidth: width ?? (variante === "stacked" ? 180 : 220),
                fontFamily: config.theme.tipografia.vchFontFamilyTitulos,
                fontSize:
                    variante === "stacked"
                        ? Math.max(18, height * 0.18)
                        : Math.max(13, height * 0.42),
                fontWeight: config.theme.tipografia.intPesoBold,
                lineHeight: 1.05,
                letterSpacing: variante === "stacked" ? "0.08em" : "0.12em",
                textTransform: "uppercase",
                color: "var(--ink-900)",
                textAlign: align,
            }}
        >
            {texto}
        </span>
    );
}
